export const identityProducts = {
  card: {
    id: "identity-card",
    name: "Identity Card",
    purchasable: false
  },
  mirror: {
    id: "mirror-show-tag",
    name: "Mirror Show Tag",
    purchasable: false
  },
  sticker: {
    id: "sticker",
    name: "Sticker",
    purchasable: false
  },
  qr: {
    id: "qr-only",
    name: "QR Only",
    purchasable: false,
    digitalOnly: true
  }
};

export function getIdentityProduct(mode) {
  return identityProducts[mode] || identityProducts.card;
}
